import { useState, useEffect, useContext } from 'react'
import { Outlet } from "react-router-dom";
import { fetch_dynamic_config } from '../../../services/configserver.js'  
import { ConfigCtxtProvider } from '../../ConfigCtxtProvider';


export default function Root() {
     
    const [dynamicConfig, setDynamicConfig] = useState({}) 

    useEffect(() => {
        fetch_dynamic_config(
            'test_config',
            (config) => setDynamicConfig(config),
            (err) => console.log('error fetching dynamic config:', err)
        )
        console.log('dynamicConfig in Root:', dynamicConfig)
    }, [])   

   
    return (
        <div id="root-layout">
            <nav id="root-nav">
                <ul>
                    <li><a href='/'>landing page</a></li>
                    <li><a href='/artist_statement'>artist statement</a></li>
                    <li><a href={`/portfolio`}>portfolio</a></li>
                    <li><a href={`/shop`}>shop</a></li>
                    <li><a href={`/contact`}>contact</a></li>
                    <li><a href={`/cdn_image_demo`}>CDN Image Demo</a></li>
                    <li><a href={`/cdn_document_demo`}>CDN Document Demo</a></li>
                </ul>
            </nav>
             <Outlet context={{ dynamicConfig }} />
        </div>
    )
}